<template>
    <div class="vc-completed">
        <div class="titleWrapper">
            <p class="subtitleItem px-5">Register</p>
            <h2 class="titleItem">新規会員登録</h2> 
        </div>
        <section class="vc-completed__box">
            <user-signup-step state="register_provisional_complete"/>
            <h2 class="vc-completed__box-heading text-center ">{{ registrationFormat }}ありがとうございます</h2>
            <ul class="mb-0 describe-list">
                <li>現在は<strong style="color: #F93672;">仮登録状態</strong>となっております。</li>
                <li v-if="!hasGroupTokenQuery">ご入力いただいたメールアドレスに本登録のご案内メールを送信しました。</li>
                <li>メールに記載のURLから本登録画面を開いて、引き続きお手続きをお願いいたします。</li>
                <li style="color: #FF0000;">※メールの有効期限は<strong>24時間</strong>です。</li>
                <li style="color: #FF0000;">有効期限を過ぎた場合は、仮登録からやり直してください。</li>
            </ul>
  
            <div class="mail-problem-box">
                <div class="mail-problem-header" @click="toggleMailHelp">
                    <p class="mail-problem">ご案内メールが届かない方へ</p>
                    <img
                    src="/images/Subtract.png"
                    alt="トグル矢印"
                    class="arrow-icon"
                    :class="{ rotated: showMailHelp }"
                    />
            </div>

            <div v-show="showMailHelp" class="mail-help-body">
                <ul>
                    <li>メールアドレスに誤りがある場合は再度 <a href="/signup?is_login=0" style="font-weight: bold;">メールアドレス送信</a> よりお手続きください。</li>
                    <li>メール受信制限をされている場合、当サービスのドメイン「<a href="#" style="font-weight: bold;">@yokumiru.jp</a>」の受信許可をお願い致します。</li>
                    <li>迷惑メールフォルダへ振り分けられている場合がございますので、ご確認ください。</li>
                </ul>
            </div>
            </div>

            <div>
                <div style="text-align: center;">
                    <p class="main-content-title">本登録が完了したらできること</p>
                    <p class="main-content-title-sm"><span style="font-size: 110%;">月額基本料</span>や<span style="font-size: 110%;">会員登録料</span>は<span style="font-weight: bold; font-size: 110%;">一切不要</span></p>
                </div>
                <div class="main-content">
                    <div class="contents">
                        <div class="content img1">
                            <img src="/images/icon-01.png" alt="10時10分を指している時計" class="content-icon" width="30%" height="auto">
                            <p>24時間いつでも<br>予約可能</p>
                        </div>
                        <div class="content img2">
                            <img src="/images/icon-02.png" alt="医師のアイコン" class="content-icon" width="28%" height="auto">
                            <p><span style="font-size: 130%;">250</span>人以上の医師に<br>選んで相談できる</p>
                        </div>
                        <div class="content img3">
                            <img src="/images/icon-03.png" alt="メッセージボックスにこんにちはと書いている" class="content-icon" width="48%" height="auto">
                            <p>日本人医師に<br>日本語で相談できる</p>
                        </div>
                    </div>
                    <div class="banner present">
                        <div class="left-box">
                          <p>お得<span style="font-size: 90%;">な</span>特典<br class="br-sp">プレゼント</p>
                        </div>
                        <div class="right-box coupon-right-box">
                          <p class="top-text">今すぐ使える限定クーポンプレゼント!!</p>
                          <div class="main-text">
                            <p>オンライン<br>医療相談料</p>
                            <strong class="price">1,000</strong>
                            <p><span style="font-size: 30px; letter-spacing: 0.2em;">OFF</span><br>クーポン</p>
                          </div>
                          <p class="note">※この特典はお一人様につき1回のみご利用いただけます</p>
                        </div>
                    </div>
                    <div class="plus">
                        <p>+</p>
                    </div>
                    <div class="banner function">
                        <div class="left-box">
                            <p>
                            無料<span style="font-size: 90%;">で使える</span><br class="br-sp">
                            便利<span style="font-size: 90%;">な</span>機能
                            </p>
                        </div>
                        <div class="right-box">
                            <div class="feature feature-usage">
                                <div class="feature-title">
                                    <p class="title1">無料使い方<br>相談</p>
                                </div>
                                <div class="feature-description">
                                    <ul style="font-weight: 600;">
                                        <li>オンライン医療相談の使い方</li>
                                        <li>どの相談料を受ければいいかのご相談</li>
                                    </ul>
                                    <p><span>などお気軽にご相談いただけます</span></p>
                                </div>
                            </div>
                            <hr style="border: none; border-top: 2px solid #ffffff; width: 95%;">
                            <div class="feature feature-search">
                                <div class="feature-title">
                                    <p class="title2">医師検索<br>機能</p>
                                </div>
                                <div class="feature-description">
                                    <p style="font-weight: 600;">
                                        医師のプロフィールや相談できるスケジュールを確認し、あなたのお悩みやライフスタイルに合った医師に相談することができます
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vc-completed__btn d-flex justify-content-center">
                <a
                    class="btn btn-link btn-yokumiru-gray vc-link-white"
                    :href="`/login${appQuery}`">
                    ログインページに戻る
                </a>
            </div>        
        </section>
    </div>
</template>

<script>
    export default {
        props: {
            appQuery: {
                type: String,
                default: '',
            }
        },

        data: function () {
            return {
                showMailHelp: false
            }
        },

        computed: {
            hasGroupTokenQuery: function () {
                return !!this.$route.query.group_token
            },

            registrationFormat: function () {
                return this.hasGroupTokenQuery ? '利用アカウント発行' : '仮登録'
            },

        },

        methods: {
            toggleMailHelp() {
                this.showMailHelp = !this.showMailHelp;
            }
        }
    }
</script>

<style lang="scss" scoped>
ul,p{
    margin:0;
}
.vc-completed {
    max-width: 950px;
    padding: 0 30px;
    margin: 0 auto;
    box-sizing: border-box;

    @media screen and (max-width:767px) {
        padding: 0 15px;
    }

    .titleWrapper {
        margin-bottom: 16px;
        text-align: center;
        .subtitleItem {
            margin-bottom: 5px;
            background-color: #F77795;
            color: white;
            border-radius: 10px;
            display: inline-block;
        }
        .titleItem {
            color: #2A2E31;
            font-size: 23px;
            font-weight: bold;
        }
    }

    .vc-completed__box {
        width: 100%;
        margin-bottom: 25px;
        padding: 30px 62px;
        background: #fff;
        box-shadow: 0px 4px 12px 0px #00000026;
        border-radius: 0;
        box-sizing: border-box;
        max-width: 900px;

        @media screen and (max-width:767px) {
            margin-bottom: 20px;
            padding: 15px;
        }

        .vc-completed__box-heading {
            margin: 24px 0 24px;
            font-size: 22px;
            font-weight: bold;
            font-feature-settings: 'palt';

            @media screen and (max-width:767px) {
                font-size: 16px;
            }
        }
        .describe-list{
            list-style: none;
            padding-bottom: 20px;
            padding-left: 0;
        }

        .arrow-icon {
            width: 16px;
            height: auto;
            transition: transform 0.3s ease;
            transform: rotate(-90deg);
            margin-left: 8px;
        }

        .arrow-icon.rotated {
            transform: rotate(0deg);
        }

        .mail-problem-box {
            border: 1px solid #FF3362;
            border-radius: 6px;
            background-color: #FEF0F4;
            padding: 10px;
            @media screen and (max-width:640px) {
                margin-left: 0;
            }
            }

        .mail-problem-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
        }

        .mail-problem {
            color: #FF3362;
            font-weight: bold;
            margin: 0;
        }

        .toggle-icon {
            font-size: 16px;
            color: rgba(249, 54, 114,0.9);
        }

        .mail-help-body {
            margin-top: 8px;
            font-size: 14px;
            color: #333;
        }
        .mail-help-body ul {
            padding-left: 16px;
            margin: 0;
        }

        .mail-help-body a {
            color: #00b3b3;
            text-decoration: underline;
        }

        .main-content-title {
            color: rgba(249, 54, 114,0.9);
            display: inline-block;
            border: 1px solid rgba(249, 54, 114,0.9);
            border-radius: 30px;
            font-weight: bold;
            padding: 8px 64px;
            font-size: 20px;
            background-color: white;
            position: relative;
            top: 26px;
            z-index: 10;
        }
        
        .main-content-title-sm {
            display: none;
        }
        
        @media screen and (max-width: 640px) {
            .main-content-title-sm {
                color: rgba(249, 54, 114,0.9);
                display: inline-block;
                border: 1px solid rgba(249, 54, 114,0.9);
                border-radius: 30px;
                padding: 8px 16px;
                font-size: 12px;
                background-color: white;
                position: relative;
                top: 26px;
                z-index: 10;
            }
            .main-content-title {
                display: none;
            }
        }
        .main-content{
            background-color: rgba(249, 54, 114,0.9);
            border-radius: 8px;
            padding: 0 20px 30px;
            @media screen and (max-width:640px) {
                padding: 0 10px 20px;
            }

        }
        .contents{
            display: flex;
            text-align: center;
            justify-content: space-between;
            padding-top: 50px;
        }

        .content{
            background: white;
            border-radius: 10px;
            width: 30%;
            font-size: 17px;
            font-weight: bold;

            @media screen and (max-width:640px) {
                font-size: 8px;
                
            }
        }
        .content p{
            padding-top: 8px;
            padding-bottom: 15px;
            @media screen and (max-width:640px) {
                padding-bottom: 4px;   
            }
        }
        .img1 {
            padding-top: 23px;
            @media screen and (max-width:640px) {
                padding-top: 15px;
            }
        }
        .img1 {
            padding-top: 23px;
            @media screen and (max-width:640px) {
                padding-top: 15px;
            }
        }
        .img2 {
            padding-top: 18px;
            @media screen and (max-width:640px) {
                padding-top: 13px;
            }
        }
        .img3 {
            padding-top: 20px;
            @media screen and (max-width:640px) {
                padding-top: 16px;
            }
        }
        .img1 img{
            @media screen and (max-width:640px) {
                width: 42%;   
            }
        }
        .img2 img{
            @media screen and (max-width:640px) {
                width: 37%;   
            }
        }
        .img3 img{
            @media screen and (max-width:640px) {
                width: 57%;   
            }
        }

        .banner{
            background: white;
            display: flex;
            margin: 20px 0;
            border-radius: 10px;
            @media screen and (max-width:640px) {
                display: block;
                background: none;
            }
        }
        .present{
            margin-top: 32px;
            @media screen and (max-width:640px) {
                margin-top: 0;
            }
        }

        .left-box {
            display: flex;
            justify-content: center;
            align-items: center;      
            text-align: center;       
            font-size: 24px;
            font-weight: bold;
            width: 30%;
            margin: 0;
            @media screen and (max-width:640px) {
                width:100%;
            }
        }
        .left-box p {
            @media screen and (max-width:640px) {
                color: black;
                display: inline-block;
                border: 1px solid rgba(249, 54, 114,0.9);
                border-radius: 30px;
                padding: 1px 16px;
                font-size: 14px;
                background-color: white;
                position: relative;
                top: 13px;
                z-index: 10;
            }
        }
        .br-sp{
            @media screen and (max-width:640px) {
                display: none;
            }
        }
        .right-box {
            text-align: center;
            border: white solid 2px;
            background-color: rgba(249, 54, 114,0.9);
            color: white;
            width: 70%;
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
            @media screen and (max-width:640px) {
                border-radius: 10px;
                width: 100%;
            }
        }
        .top-text {
            font-size: 17px;
            font-weight: bold;
            margin-top: 7px;
            margin-bottom: 4px;
            @media screen and (max-width:640px) {
                font-size: 11px;
            }
        }
        .coupon-right-box {
            padding: 16px 0;
            @media screen and (max-width:640px) {
                padding: 9px 0 0;
            }
        }
        .main-text{
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            margin-top: -25px;
            margin-bottom: 4px;
            @media screen and (max-width:640px) {
                gap: 6px;
                margin-top: -9px;
                margin-bottom: 4px;
            }
        }
        .main-text p {
            font-size: 20px;
            font-weight: bold;
            line-height: 25px;
            text-align: left;
            @media screen and (max-width:640px) {
                font-size: 15px;
                line-height: 18px;
            }
        }
        .price {
            font-size: 65px;
            margin-top: -5px;
            @media screen and (max-width:640px) {
                font-size: 41px;
            }
        }
        .note{
            margin-top: -15px;
            margin-bottom: 5px;
            font-size: 13px;
            @media screen and (max-width:640px) {
                margin-top: -8px;
                font-size: 9px;
            }
        }
        .plus{
            text-align: center;
            font-size: 60px;
            font-weight: lighter;
            color: white;
            margin-top: -45px;
            margin-bottom: -34px;
            @media screen and (max-width:640px) {
                font-size: 49px;
                margin-top: -40px;
                margin-bottom: -45px;
            }
        }
        .function{
            margin: 20px 0;
            @media screen and (max-width:640px) {
                margin: 20px 0 0;
            }
        }
        .feature{
            display: flex;
            margin: 20px 0;
        }
        .feature-usage {
            @media screen and (max-width:640px) {
                margin: 20px 0 -6px;
            }
        }
        .feature-search {
            @media screen and (max-width:640px) {
                margin: -7px 0 10px;
            }
        }
        .feature-title{
            display: flex;
            justify-content: center;
            align-items: center;      
            text-align: center;       
            font-size: 20px;
            color: rgba(249, 54, 114,0.9);
            width: 40%;
            @media screen and (max-width:640px) {
                font-size: 14px;
            }
        }
        .feature-title p{
           background: white;
           font-weight: bold;
           line-height: 1.5;
           border-radius: 8px;
        }
        .title1{
            padding: 3px 20px;
            @media screen and(max-width:640px) {
                padding: 3px 15px;
            }
        }
        .title2{
            padding: 3px 30px;
            @media screen and(max-width:640px) {
                padding: 3px 22px;
            }
        }

        .feature-description{
            font-size: 14px;
            width: 57%;
            @media screen and (max-width:640px) {
                font-size: 9px;
            }
        }

        .feature-description ul{
            text-align: left;
            padding-left: 8px;
        }
        .feature-description span{
            font-size: 13px;
            font-weight: normal;
            padding-left: 12px;
            @media screen and (max-width:640px) {
                font-size: 9px;
                padding-left: 0;
            }
        }

        .vc-completed__box-text {
            margin-bottom: 0;
            font-size: 16px;
            font-feature-settings: 'palt';

            @media screen and (max-width:767px) {
                font-size: 12px;
            }
        }
    }

    .vc-completed__btn {
        margin: 55px 0;

        @media screen and (max-width:767px) {
            margin: 28px 0;
        }

        a.btn {
            padding: 12px 20px;
            font-feature-settings: 'palt';
            text-decoration: none;

            @media screen and (max-width:767px) {
                padding: 3px 20px;
                font-size: 12px;
            }
        }
    }

    .vc-link-black {
        color: #212529;
    }

    .vc-link-white {
        color: #fff;
    }
}
</style>
